import React from "react";
import { Form } from "react-bootstrap";

const isFirefox = typeof InstallTrigger !== "undefined";

const DateTimeInputFormik = (props) => {
  const { formik, field, pickTime, evento, disabled } = props;
  const type = pickTime ? "datetime-local" : "date";
  let value = formik.values[field];

  // Desprezar o time
  if (value && value.length > 11 && type === "date") {
    value = value.substring(0, 10);
  }

  // Desprezar Segundos e timezone (se houver)
  if (value && value.length >= 16 && type === "datetime-local") {
    value = value.substring(0, 16);
  }

  // Função para verificar o ano
  const isYearValid = (dateValue) => {
    if (!dateValue) return true; // Se o valor for vazio, é válido
    const year = dateValue.split("-")[0]; // Extrair o ano
    return year.length <= 4; // O ano não deve ter mais que 4 dígitos
  };

  // Modificar o handleChange para incluir a validação do ano
  const handleChange = (e) => {
    const inputValue = e.target.value;

    if (isYearValid(inputValue)) {
      formik.handleChange(e); // Se o ano for válido, continue com a mudança
    } else {
      formik.setFieldError(field, "Ano inválido, deve conter no máximo 4 dígitos");
    }
  };

  if (isFirefox && pickTime) {
    console.error(
      `O Firefox não suporta o input type "datetime-local". Certifique-se de validar o formato do valor "${field}"`,
    );
  }

  return (
    <>
      <Form.Control
        id={field}
        name={field}
        type={type}
        disabled={formik.isSubmitting || disabled}
        value={value}
        onChange={handleChange} // Usar a função handleChange customizada
        onBlur={evento}
        isInvalid={formik.touched[field] && formik.errors[field]}
      />
      {(formik.touched[field] || formik.dirty) && formik.errors[field] && (
        <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
      )}
    </>
  );
};

export default DateTimeInputFormik;
